module.exports = __webpack_public_path__ + "silver_badge.webp";